/**
 * Lookback switcher for the diagnostics tabs.
 *
 * Deliberately `.chip`, not `.tabs__tab`. Three of these tabs need their own time control, and
 * the first version of them reused the tab-bar classes -- which put a second row of tab-looking
 * buttons directly under the page's real tab bar, and made ".tabs__tab" ambiguous for anything
 * (tests included) trying to address the page tabs. The chip row is the control this console
 * already uses for in-card filtering (TrafficQualityReportingTab's dimension switcher,
 * DateRangePicker's presets), so it reads as a filter rather than as navigation.
 *
 * These endpoints take a `days` integer, not a from/to pair, so DateRangePicker itself does not
 * fit -- its custom-range inputs would have nothing to bind to.
 */
const WINDOWS = [
  { days: 1, label: '24 hours' },
  { days: 7, label: '7 days' },
  { days: 30, label: '30 days' },
];

export default function WindowPicker({ days, onChange, disabled = false }) {
  return (
    <div className="toolbar__filters">
      {WINDOWS.map((w) => (
        <button
          key={w.days}
          type="button"
          className={`chip${days === w.days ? ' chip--active' : ''}`}
          onClick={() => onChange(w.days)}
          disabled={disabled}
        >
          {w.label}
        </button>
      ))}
    </div>
  );
}
